export default "__VITE_ASSET__Dt8w12Wv__"